import { Checkbox, Form, FormInstance, Row } from "antd";
import { useEffect } from "react";
import { DaysInput } from "./DaysInput";

type SettingsRowProps = {
  form: FormInstance;
  label: string;
  emailName: string;
  mailName: string;
  sendAfter?: boolean;
};

export const SettingsRow = ({
  form,
  label,
  emailName,
  mailName,
  sendAfter = false,
}: SettingsRowProps) => {
  const emailValue = Form.useWatch(emailName, form);

  useEffect(() => {
    const val = form.getFieldValue(mailName);

    if (sendAfter && !emailValue && !val) {
      form.setFieldValue(mailName, 1);
    }
  }, [emailValue, form, mailName, sendAfter]);

  return (
    <Row className="my-2 align-center position-relative">
      <span className="type-col px-2">{label}</span>
      <Form.Item
        name={emailName}
        className="email-col d-flex justify-center mb-0 mx-2"
        valuePropName="checked"
      >
        <Checkbox />
      </Form.Item>
      {!sendAfter ? (
        <Form.Item
          name={mailName}
          className="mail-col d-flex justify-center mb-0 mx-2"
          valuePropName="checked"
        >
          <Checkbox />
        </Form.Item>
      ) : (
        <>{emailValue && <DaysInput form={form} name={mailName} />}</>
      )}
    </Row>
  );
};
